import { createContext, useContext } from 'react';

export interface FormStateType {
  tone: string;
  type: string;
  prompt: string;
  drafts: number;
  language: string;
}

export interface EmailContextType {
  emailContent: string[] | null; // Storing multiple responses as an array of strings
  updateEmailContent: (data: string[]) => void; // Function to update email content
  isGenerating: boolean; // State to track API call status
  setIsGenerating: (e: boolean) => void; // Function to update loading state
  updateEmailAtIndex: (index: number, newContent: string) => void;
  formState: FormStateType; // New form state
  setFormState: (state: FormStateType) => void;
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
  isPanelOpen: boolean; // State to track if edit panel is open
  setIsPanelOpen: (isOpen: boolean) => void; // Function to update panel state
}

// Create context with initial values
export const EmailContext = createContext<EmailContextType>({
  emailContent: null,
  updateEmailContent: () => {},
  isGenerating: false,
  setIsGenerating: () => {},
  updateEmailAtIndex: () => {},
  formState: {
    tone: '',
    type: '',
    prompt: '',
    drafts: 1,
    language: '',
  },
  setFormState: () => {},
  activeIndex: 1,
  setActiveIndex: () => {},
  isPanelOpen: false,
  setIsPanelOpen: () => {},
});

// Custom hook to access EmailContext
export const useEmailContext = () => useContext(EmailContext);
